const FacetHeading = ({ name }) => {
  return <h5 className="fw-normal">{name}</h5>
}
export { FacetHeading }
